import dayjs from 'dayjs';

export const generateFilepath = (
  type: 'LeaveRequest' | 'Overseas' | 'ITReq' | 'MR' | 'TR' | 'TR_PRICING',
  filename: string,
  empNumber?: string
): string => {
  const timestamp = dayjs().format('DDMMYYYYHHmmss');
  const segments = filename.split('.');
  const fileExt = segments[segments.length - 1];

  switch (type) {
    case 'LeaveRequest':
      return `${empNumber}_${timestamp}.${fileExt}`;
    case 'ITReq':
      return `ITReq_${timestamp}.${fileExt}`;
    case 'Overseas':
      return `OverseasMission_${timestamp}.${fileExt}`;
    case 'MR':
      return `MR_${timestamp}.${fileExt}`;
    case 'TR':
      return `TR_${timestamp}.${fileExt}`;
    case 'TR_PRICING':
      return `TR_PRICING_${timestamp}.${fileExt}`;
    default:
      return '';
  }
};
